import React, { Component } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';


const styles = {
  main: {
    maxWidth: '400px',
    minWidth: '250px',
  },
  paper: {
    padding: '60px 30px',
  },
  header: {
    paddingBottom: '20px',
  },
  button: {
    margin: '20px 0 10px ',
  },
  bottom: {
    marginTop: '20px',
  },
  error: {
    color: '#fff',
    fontSize: '14px',
    backgroundColor: '#f44336',
    padding: '1px',
    marginTop: '10px',
    marginBottom: '15px',
  }
};

class Verify extends Component {
  renderResendCode() {
    const { handleResend } = this.props;
    return (
      <button onClick={handleResend}>
        Resend Code
      </button>
    );
  }


  render() {
    const {
      error,
      currentlySending,
      loading,
      mfacode,
      errorMFA,
      handleSubmit,
      handleMfaCodeChange,
      logo,
      contactText,
      mfaText,
      handleCheckBoxChangedEvent,      
      shouldDisplay,
      rememberMe
    } = this.props;

    return (
      <div className="col-xs-10 col-sm-6 col-md-4 col-lg-4" style={styles.main}>
        <div className="box">
          <Paper elevation={3} style={styles.paper}>
            <form action="#" method="POST" onSubmit={handleSubmit}>
              <div className="row center-xs">
                <div className="col-xs-12">
                  <div className="box">{logo()}</div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box">
                    <h2>Enter Verification Code</h2>
                    <p>{mfaText}</p>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    {currentlySending || loading ? (
                      <CircularProgress size={25} thickness={3} />
                    ) : (
                      <ErrorMessage error={error} />
                    )}
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box">
                    <FormControl fullWidth error={errorMFA ? true : false} aria-describedby="mfa">
                      <InputLabel shrink htmlFor="mfa-label">
                        Verification Code
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="mfa"
                        value={mfacode}
                        onChange={handleMfaCodeChange}
                      />
                      <FormHelperText id="password-error-text">{errorMFA}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    <FormControl>
                    <FormControlLabel
                      control={<Checkbox id="rememberMe" checked={rememberMe} onChange={handleCheckBoxChangedEvent} />}
                      label="Remember me on this device"
                      style={shouldDisplay ? { display: 'flex' } : { display: 'none' } }
                    />
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    <div />
                    <Button
                      variant="contained"
                      type="submit"
                      id="verify-button"
                      style={styles.button}
                      className="submitButton"
                      color="primary"
                      disabled={currentlySending || loading ? true : false}
                    >
                      Verify
                    </Button>
                  </div>
                </div>
              
                <div className="col-xs-8">
                  <div className="box">
                    {contactText()}                   
                  </div>
                </div>
              </div>
            </form>
          </Paper>
          <a href="http://defisolutions.com" target="_blank" rel="noopener noreferrer">
            <img src={poweredLogo} style={styles.bottom} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default Verify;
